import { SVGProps } from 'react';

function House(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M22.868 8.947 12 .747l-10.878 8.2c-.225.208-.36.495-.377.8V22.27a.98.98 0 0 0 .978.978h6.522V18a3.75 3.75 0 0 1 7.5 0v5.25h6.521a.982.982 0 0 0 .98-.978V9.747a1.18 1.18 0 0 0-.378-.8Z"
          stroke="#22242A"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

House.defaultProps = {
  role: 'graphics-document',
};

export default House;
